import { Routes } from '@/constants/routes';

export const GetStartedLink = { label: 'Get started', to: Routes.getStarted };

export const ContactLink = { label: 'Contact us', to: Routes.contact };

export const PrimaryNavigation = [
  { label: 'Home', to: Routes.home },
  { label: 'About us', to: Routes.about },
  ContactLink,
];

export const FooterNavigation = [...PrimaryNavigation, GetStartedLink];